import _toString from "lodash/toString"

export const getUsersWorkspaceAclsData = state => state.usersAcls.get("workspaces")

export const getUsersWorkspaceAcl = (state, workspaceId) =>
  state.usersAcls.getIn(["workspaces", _toString(workspaceId)])

export const getUsersDawgAcl = (state, dawgId) =>
  state.usersAcls.getIn(["dawgs", _toString(dawgId)])
